import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { HelpTicket } from '@shared/models/help-ticket.model';

@Component({
  selector: 'miq-ticket-detail-additional-info',
  templateUrl: './ticket-detail-additional-info.component.html',
  styleUrls: ['./ticket-detail-additional-info.component.scss'],
  standalone: false,
})
export class TicketDetailAdditionalInfoComponent implements OnInit {
  @Input() public ticketDetail: HelpTicket;
  @Input() public isProfile: boolean;
  @Input() public page: boolean;
  @Output() public jiraNumberCtrlEvent = new EventEmitter<UntypedFormControl>();
  @Output() public estimatedReleaseDateCtrlEvent = new EventEmitter<UntypedFormControl>();

  public jiraNumberCtrl = new UntypedFormControl();
  public estimatedReleaseDateCtrl = new UntypedFormControl();

  ngOnInit() {
    this.jiraNumberCtrl.setValue(this.ticketDetail.jiraNumber);
    this.estimatedReleaseDateCtrl.setValue(this.ticketDetail.estimatedReleaseDate);
    this.jiraNumberCtrl.valueChanges.subscribe(() => this.jiraNumberCtrlEvent.emit(this.jiraNumberCtrl));
    this.estimatedReleaseDateCtrl.valueChanges.subscribe(() =>
      this.estimatedReleaseDateCtrlEvent.emit(this.estimatedReleaseDateCtrl)
    );
  }
}
